import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IBookAccessResultVm } from '../book-access-result-vm.model';
import { IBookAccessPackageIm } from '../book-access-package-im.model';
@Injectable({ providedIn: 'root' })
export class BookAccessGeneratorService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/BookAccessGenerator`;
  }
  post(bookAccessPackageIm: IBookAccessPackageIm): Observable<IBookAccessResultVm> {
    const headers = this.createHeaders();
    return this.http.post<IBookAccessResultVm>(this.baseUrl, bookAccessPackageIm, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
